import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {ServiceDescriptionsPage} from "./-page/service-descriptions.page";
import {ServiceDescriptionsPending} from "./-page/service-descriptions.pending";

export const Route = createFileRoute("/_app/engineering/services/$serviceId/descriptions/")({
  component: RouteComponent,
  pendingComponent: ServiceDescriptionsPending,
  staticData: {meta: {labelDescriptor: routeMessages.descriptions}},
});

function RouteComponent() {
  const {serviceId} = useParams({strict: false}) as {serviceId: string};
  const {includeDeleted} = Route.useSearch();

  return <ServiceDescriptionsPage serviceId={serviceId} includeDeleted={includeDeleted} />;
}
